import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

type CakeMode = 'custom' | 'category' | 'addons';

interface CakeTypeSelectorProps {
  onModeChange: (mode: CakeMode) => void;
  selectedMode: CakeMode;
}

const CakeTypeSelector: React.FC<CakeTypeSelectorProps> = ({
  onModeChange,
  selectedMode,
}) => {
  const handleModeChange = (
    _event: React.MouseEvent<HTMLElement>,
    newMode: CakeMode | null
  ) => {
    if (newMode !== null) {
      onModeChange(newMode);
    }
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='subtitle1' gutterBottom>
        Select Cake Type
      </Typography>
      <ToggleButtonGroup
        value={selectedMode}
        exclusive
        onChange={handleModeChange}
        aria-label='cake type selection'
        fullWidth
        sx={{
          '& .MuiToggleButton-root': {
            borderColor: '#EE3750',
            color: '#666',
            '&.Mui-selected': {
              backgroundColor: '#EE3750',
              color: '#fff',
              '&:hover': {
                backgroundColor: '#EE3750',
              },
            },
          },
        }}
      >
        <ToggleButton value='custom' aria-label='custom cake'>
          Create Custom Cake
        </ToggleButton>
        <ToggleButton value='category' aria-label='category cake'>
          Select from Category Cakes
        </ToggleButton>
        <ToggleButton value='addons' aria-label='addons'>
          Addons
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};

export default CakeTypeSelector;

